export const alphaSpaceRegex = /^[a-zA-Z\s]+$/;

export const alphaRegex = /^[aA-zZ\s]+$/;

export const alphaNumericRegex = /^[aA-zZ0-9]+$/;

export const alphaNumericNospaceRegex = /^[a-zA-Z0-9]*$/;

export const alphaNumericDotRegex = /^[0-9a-z.]+$/;

export const licenseRegex = /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/;

export const numericRegex = /^[0-9]+$/;

export const alphaNumericHyphenRegex = /^[aA-zZ0-9-]+$/;

export const geoLocationRegex = '^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}';

export const latitudeRegex = /^(\+|-)?(?:90(?:(?:\.0{1,20})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,20})?))$/;

export const longitudeRegex = /^(\+|-)?((\d((\.)|\.\d{1,20})?)|(0*?\d\d((\.)|\.\d{1,20})?)|(0*?1[0-7]\d((\.)|\.\d{1,20})?)|(0*?180((\.)|\.0{1,20})?))$/

export const pancardRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

export const aadharNumberRegex = /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/;

export const ifscCodeRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

export const imageSupportFormat = ["image/jpg", "image/jpeg", "image/png"];

export const pdfSupportFormat = ["application/pdf"];

export const docSupportFormat = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'];

export const amountRegex = /^[1-9]+$/;

export const requiredMsg = (input) => `The ${input} field is required.`;

export const alphaSpaceMsg = (input) => `The ${input} field must only contain letters and space.`;

export const positiveMsg = (input) => `The ${input} field must only contain positive numbers.`;

export const integerMsg = (input) => `The ${input} field must only contain numbers.`;

export const oneOfMsg = (input) => `The ${input} field is required.`;

export const urlMsg = (input) => `The ${input} field is not valid url.`;

export const imageMsg = (input) => `The ${input} field must be an image of type jpg, jpeg, png, gif.`;

export const pdfMsg = (input) => `The ${input} field must be an file of type pdf.`;

export const lengthMsg = (input, length) => `The ${input} field must be ${length} digits.`;

export const emailMsg = (input) => `The ${input} must be a valid email address.`;

export const alphaNumericDotMsg = (input) => `The ${input} must contain only alphabet, numbers and dot`

export const alphaMsg = (input) => `The ${input} field must only contain letters.`;

export const geoLocationMsg = (input) => `The ${input} field is invalid.`;

export const LongitudeMsg = (input) => `The Longitude must be between -180 to 180`;

export const LatitudeMsg = (inpt) => `The Latitude must be between -90 to 90 `;

export const pancardMsg = (input) => `The ${input} field is invalid.`;

export const aadharNumberMsg = (input) => `The ${input} field is invalid.`;

export const alphaNumericMsg = (input) => `The ${input} field must only contain letters and numbers.`;

export const alphaNumericHyphenMsg = (input) => `The ${input} field must only contain letters, numbers and hyphen.`;

export const minMsg = (input, value) => `The ${input} must be at least ${value}.`;

export const maxMsg = (input, value) => `The ${input} field must only contain ${value} letters.`;

export const fileSizeMsg = (input, value) => `The ${input} field must less than or equal to ${value} kb.`;

export const charLenMsg = (input, value) => `The ${input} should be equal to ${value} character(s).`;

export const charLessThanMsg = (input, value) => `The ${input} should be less than or equal to ${value} character(s).`;

export const invalidMsg = (input) => `The ${input} field is invalid.`;

export const amountMsg = (input) => `The ${input} must be minimum 1`;
export const pdfAndImageMsg = (input) => `The ${input} field must be an file of type pdf,jpg, jpeg, png, gif..`;
export const FILESIZE = 500000
